import API from "@/Api/API";
import Acl from "@/Api/resources/Acl";
import Auth from "@/Api/resources/Auth";
import BetaRegistration from "@/Api/resources/BetaRegistration";
import Library from "@/Api/resources/Library";
import Scenes from "@/Api/resources/Scenes";
import Statistics from "@/Api/resources/Statistics";
import Subscriptions from "@/Api/resources/Subscriptions";
import Users from "@/Api/resources/Users";

export default class APIHelper {
	api = new API();
	auth = new Auth(this.api);
	betaRegistration = new BetaRegistration(this.api);
	scenes = new Scenes(this.api);
	library = new Library(this.api);
	users = new Users(this.api);
	acl = new Acl(this.api);
	statistics = new Statistics(this.api);
	subscriptions = new Subscriptions(this.api);
}
